export default "__VITE_ASSET__4ad09aa3__"